import React, { useState } from 'react';
import { Icon } from '../Icons';
import { Text } from '../Text';

import cx from 'classnames';

import './Accordion.scss';

interface AccordionProps {
  title?: string;
  content: string | React.ReactNode;
  isExpanded: boolean;
  toggleAccordion: () => void;
}

export const AccordionItem: React.FC<AccordionProps> = ({
  title,
  content,
  isExpanded,
  toggleAccordion,
}) => {
  return (
    <div className="accordion-item">
      <button
        aria-expanded={isExpanded}
        onClick={toggleAccordion}
        className="accordion-button"
      >
        <Icon.RightArrow className="accordion-icon" />
        <Text.HeaderM className="accordion-title">{title}</Text.HeaderM>
      </button>
      <div className="accordion-content">{content}</div>
    </div>
  );
};

interface SingleAccordionProps {
  title: string;
  children: React.ReactNode;
  expiredHeight?: number;
  AccordionIcon?: Icon.IconType;
  accordionClassName?: string;
  accordionContentClassName?: string;
  accordionTitleClassName?: string;
  onExpand?: () => void;
  onClose?: () => void;
}

export const SingleAccordionItem: React.FC<SingleAccordionProps> = ({
  title,
  children,
  expiredHeight = 300,
  AccordionIcon,
  accordionClassName,
  accordionContentClassName,
  accordionTitleClassName,
  onExpand = () => undefined,
  onClose = () => undefined,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const renderIcon = () => {
    if (!AccordionIcon) {
      return null;
    }
    return <AccordionIcon className="single-accordion-item--icon" />;
  };

  return (
    <div className={cx('single-accordion-item')}>
      <button
        type="button"
        onClick={() => {
          if (isExpanded) {
            onClose();
          } else {
            onExpand();
          }
          setIsExpanded(!isExpanded);
        }}
        className={cx('accordion-button', accordionClassName)}
      >
        <Icon.RightArrow
          className="accordion-icon"
          style={{
            transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
          }}
        />
        <Text.HeaderS className={cx('accordion-title', accordionTitleClassName)}>
          {title}
        </Text.HeaderS>
        {renderIcon()}
      </button>
      <div
        className={cx('accordion-content', accordionContentClassName)}
        style={{
          maxHeight: isExpanded ? expiredHeight : 0,
          opacity: isExpanded ? 1 : 0,
        }}
      >
        {children}
      </div>
    </div>
  );
};
